import React, { useState, useEffect } from "react";
import "./ChooseFlightForm.css";
import { NotFound, Paginations } from "../../../../components";
import { axiosGet } from "../../../../utils/apis/api";
import { SingleCalendar, SpinnerLoading } from "../../../../components";
import dayjs from "dayjs";
import { Col, Row } from "react-bootstrap";
import Flight from "../../../../components/Flight/Flight";
import GlobalModal from "../AddModal/GlobalModal";
import { TextField, Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { useTranslation } from "../../../../contexts/TranslationContext";
import Switch from "@mui/material/Switch";
import AddService from "../../../../Features/CustomPackages/Components/AddService/AddService";
import { getUtcDateWithLocalMidnight } from "../../../../utils/GeneralFunctions";
import flightIcon from "../../../../assets/images/packages/svg/flight.svg";


const ChooseFlightForm = ({ url, onReturn, dates, selectedDestination,quotationId, setItems , addComponentToQuot, updateComponentFromQuot, selectedComponent}) => {
  const formattedStart = dates?.startDate
    ? dayjs(dates.startDate).format("MMM D")
    : null;
  const formattedEnd = dates?.endDate
    ? dayjs(dates.endDate).format("MMM D")
    : null;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const resultsPerPage = 10;
  const [showPopUp, setShowPopUp] = useState(false);
  const [flightSelected, setFlightSelected] = useState(null);
  const { t } = useTranslation();
  const [oneWay, setOneWay] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(dates?.startDate? getUtcDateWithLocalMidnight(new Date (dates?.startDate )): null);
  const [tempEndDate, setTempEndDate] = useState(dates?.endDate?  getUtcDateWithLocalMidnight(new Date (dates?.endDate )) : null);
  const [fromDestination, setFromDestination] = useState(null);
  const [startDate, setStartDate] = useState(dates?.startDate || null);
  const [endDate, setEndDate] = useState(dates?.endDate || null);

  const [initialFlight,  setInitialFlight] = useState(null);  

  const handleToggle = (event) => {
    setOneWay(event.target.checked);
  };

  const [apiError, setApiError] = useState(null); // New state for API errors
  const [errorData, setErrorData] = useState({
    // New state for error details
    code: "",
    message: "",
    description: "",
  });

  /* ─────────────── AddService (Flight) ─────────────── */
  const [showSrv,       setShowSrv]       = useState(false);
  const [preFlightData, setPreFlightData] = useState(null);

  const openAddService = (flightPayload) => {
    setPreFlightData(flightPayload);
    setShowSrv(true);
  };


  const Lang = Cookies.get("preferred_language") || "en";

  const [locations, setLocations] = useState([]);
  const [hasMorelocations, setHasMorelocations] = useState(true);
  const PAGE_LIMIT = 50;

  const [toDestination, setToDestination] = useState(
    selectedDestination || null
  );




  const fetchLocations = async (
    newSearch = "",
    newStart = 0,
    append = false
  ) => {
    if (!hasMorelocations && append) return; // Stop if no more items
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search: newSearch,
          start: newStart,
          limit: PAGE_LIMIT,
        }
      );

      const newItems = Array.isArray(response.result?.locations)
        ? response.result?.locations
        : []; // Ensure array
      setLocations((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMorelocations(newItems.length === PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching items:", error);
      setLocations([]); // Ensure items is always an array
    } finally {
    }
  };

  const fetchData = async (
    pageNumber = 1,
    start_date,
    end_date,
    to_destination,
    from_destination
  ) => {
    try {
      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.flight.flight.flight?start=${start}&limit=${resultsPerPage}`;

      if (start_date) {
        apiUrl += `&from_date=${dayjs(start_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )}`;
      }

      if (!oneWay && end_date) {
        apiUrl += `&to_date=${dayjs(end_date).format("YYYY-MM-DD HH:mm:ss")}`;
      }

      if (to_destination) {
        const to_dest = to_destination.location ; //?? to_destination.name
        apiUrl += `&to_destination=${to_dest}`;
      }

      if (from_destination) {
        const from_dest = from_destination.location ; //?? from_destination.name
        apiUrl += `&from_destination=${from_dest}`;
      }

      setIsLoading(true);
      setApiError(null);
      const response = await axiosGet(apiUrl);

      if (response.error) {
        // Handle API errors (non-200 responses)
        const errorCode = response.error.code || "500";
        const errorMsg = response.error.message || t("UnknownError");

        setErrorData({
          code: errorCode,
          message: errorMsg,
          description: t("FlightFetchError"),
        });
        setApiError(true);
        setData([]);
      } else {
        // Process successful response
        const result = response.result;
        setCurrentPage(result.pagination.metadata.current_page);
        setTotalPages(result.pagination.metadata.total_pages);
        setData(result.items);
      }
    } catch (error) {
      // Handle network errors or unexpected exceptions
      setErrorData({
        code: "NETWORK_ERR",
        message: t("NetworkError"),
        description: t("ConnectionFailed"),
      });
      setApiError(true);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const onPageChange = (pageNumber) => {
    fetchData(pageNumber, startDate, endDate, toDestination, fromDestination);
  };

  useEffect(() => {
    if (selectedDestination) {
      setToDestination(selectedDestination);
    }

    if (dates?.startDate) {
      setStartDate(dates.startDate);
    }

    if (dates?.endDate) {
      setEndDate(dates.endDate);
    }
  }, []);

  useEffect(() => {
    fetchData(1, startDate, endDate, toDestination, fromDestination);
  }, [startDate, endDate, toDestination, fromDestination, oneWay]);


    if (showSrv) {
    return (
      <AddService
        url={url}
        quotationId={quotationId}
        selectedServices={["Flight"]}
        initialFlight={preFlightData}
        editingComponent={selectedComponent} 
        selectedDestination={selectedDestination}
        selectedDates={{ startDate, endDate }}
        onSubmit={(items) => {
          setShowSrv(false);
          onReturn(items);      
        }}
        
        onNext={(item) => {
          return addComponentToQuot(item, { isSubLoading: true });
        }}
        onUpdateQuot={(start_date,end_date ) => {
          
          return updateComponentFromQuot(start_date,end_date, preFlightData.name, { isSubLoading: true });
           // setShowAddServiceForm(false);
         }}
        onReturn={() => setShowSrv(false)}
        setItems={setItems}
      />
    );
  }

  if (isLoading) {
    return (
      <div className="loading-container">
        <SpinnerLoading />
      </div>
    );
  }
  return (
    <div className="choose-flight-container">
      <button className="hotel-form-backbtn" onClick={() => onReturn()}>
      {Lang === "ar" ? (
          <>
            {t("BackToPlan")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t("BackToPlan")}
          </>
        )}
      </button>

      <div className="component-form-title">
        <div className="component-form-title-icon">
          <img src={flightIcon} alt="hotel"/>
        </div>
        <div>{t("Flights")}</div>
      </div>

      <div className="flight-form-dates-nights">
        {`${formattedStart} - ${formattedEnd} ${t("In")} ${selectedDestination.location_name}`}
      </div>
      <Row style={{ alignItems: "center" }}>
        <Col xl={3} md={6}>
          <div className="hotel-form-input-container">
            <label className="hotel-form-input-label">
              {t("FromDestination")}
            </label>
            <Autocomplete
              dir={Lang === "ar" ? "rtl" : "ltr"}
              style={{ width: "100%" }}
              options={locations}
              value={fromDestination}
              onChange={(_, value) => setFromDestination(value)}
              onInputChange={(event, value, reason) => {
                if (reason === "input") {
                  fetchLocations(value);
                }
              }}
              onFocus={() => fetchLocations("", 0, false)}
              getOptionLabel={(option) => option?.location_name || ""}
              sx={{
                ".MuiAutocomplete-inputRoot": {
                  fontSize: "12px",
                  flexDirection: Lang === "ar" ? "row-reverse" : "row",
                },
                ".MuiAutocomplete-endAdornment": {
                  left: Lang === "ar" ? "9 !important" : "unset !important",
                  right: Lang === "ar" ? "unset !important" : "9 !important",
                },
                ".MuiInputBase-input": {
                  textAlign: Lang === "ar" ? "right" : "left",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder={t("FromDestination")}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      direction: Lang === "ar" ? "rtl" : "ltr",
                    },
                    sx: {
                      backgroundColor: "#FFF",
                      borderRadius: "6px",
                      padding: "9px 15px !important",
                      fontFamily: '"Dmsans400"',
                      fontSize: "14px !important",
                      fontWeight: 400,
                      letterSpacing: "0.25px",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.name}>
                  {option.location_name}
                </li>
              )}
            />
          </div>
        </Col>

        <Col xl={3} md={6}>
          <div className="hotel-form-input-container">
            <label className="hotel-form-input-label">
              {" "}
              {t("ToDestination")}
            </label>
            <Autocomplete
              readOnly
              dir={Lang === "ar" ? "rtl" : "ltr"}
              style={{ width: "100%" }}
              options={locations}
              value={toDestination}
              onChange={(_, value) => setToDestination(value)}
              onInputChange={(event, value, reason) => {
                if (reason === "input") {
                  fetchLocations(value);
                }
              }}
              getOptionLabel={(option) => option?.location_name || ""}
              onFocus={() => fetchLocations("", 0, false)}
              sx={{
                ".MuiAutocomplete-inputRoot": {
                  fontSize: "12px",
                  flexDirection: Lang === "ar" ? "row-reverse" : "row",
                },
                ".MuiAutocomplete-endAdornment": {
                  left: Lang === "ar" ? "9 !important" : "unset !important",
                  right: Lang === "ar" ? "unset !important" : "9 !important",
                },
                ".MuiInputBase-input": {
                  textAlign: Lang === "ar" ? "right" : "left",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder={t("ToDestination")}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      direction: Lang === "ar" ? "rtl" : "ltr",
                    },
                    sx: {
                      backgroundColor: "#FFF",
                      borderRadius: "6px",
                      padding: "9px 15px !important",
                      fontFamily: '"Dmsans400"',
                      fontSize: "14px !important",
                      fontWeight: 400,
                      letterSpacing: "0.25px",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.name}>
                  {option.location_name}
                </li>
              )}
            />
          </div>
        </Col>

        <Col xl={3} md={6}>
          <div className="hotel-form-input-container">
            <label className="hotel-form-input-label">
              {t("DepartureDate")}
            </label>
            <SingleCalendar
              // value={tempStartDate ? getUtcDateWithLocalMidnight(new Date (tempStartDate)) : startDate? getUtcDateWithLocalMidnight(new Date (startDate)): null}
              
              value={tempStartDate ?new Date(tempStartDate) : null}

              onChange={(e) => {
                setTempStartDate(e?.value);
              }}

              onHide={() => { 
                if (
                  !startDate ||
                  dayjs(tempStartDate).format("YYYY-MM-DD HH:mm") !==
                    dayjs(startDate).format("YYYY-MM-DD HH:mm")
                ) {
                  setStartDate(tempStartDate);
                }
              }}
              placeholder={
                startDate
                  ? dayjs(startDate).format("YYYY-MM-DD HH:mm:ss")
                  : t("DepartureDate")
              }
              min={new Date(dates.startDate)}
              max={
                endDate
                  ? new Date(
                      Math.min(
                        new Date(endDate).getTime(),
                        new Date(dates.endDate).getTime()
                      )
                    )
                  : new Date(dates.endDate)
              }
              viewDate={new Date(dates.startDate)}
              className="custom-calendar-input"
              onClearButtonClick={()=>{setStartDate(null); setTempStartDate(null)}}
            />
          </div>
        </Col>

        <Col xl={1} md={6}>
          <div
            className="hotel-form-input-container"
            style={{ display: "flex", alignItems: "center" }}
          >
            <label className="hotel-form-input-label" style={{ marginLeft: 8 }}>
              {t("OneWay")}
            </label>
            <Switch
              checked={oneWay}
              onChange={handleToggle}
              color="primary"
              inputProps={{ "aria-label": "one way switch" }}
            />
          </div>
        </Col>

        {!oneWay && (
          <Col xl={3} md={6}>
            <div className="hotel-form-input-container">
              <label className="hotel-form-input-label">
                {t("ReturnDate")}
              </label>
              <SingleCalendar
                // value={tempEndDate? new Date(tempEndDate): endDate ? getUtcDateWithLocalMidnight(new Date (endDate)) : null}
                value={tempEndDate ?new Date(tempEndDate) : null}
                onChange={(e) => setTempEndDate(e?.value)}
                onHide={() => {
                  if (
                    !endDate ||
                    dayjs(tempEndDate).format("YYYY-MM-DD HH:mm") !==
                      dayjs(endDate).format("YYYY-MM-DD HH:mm")
                  ) {
                    setEndDate(tempEndDate);
                  }
                }}
                min={
                  startDate
                    ? new Date(
                        Math.max(
                          new Date(startDate).getTime(),
                          new Date(dates.startDate).getTime()
                        )
                      )
                    : new Date(dates.startDate)
                }
                max={new Date(dates.endDate)}
                placeholder={
                  endDate
                    ? dayjs(endDate).format("YYYY-MM-DD HH:mm:ss")
                    : t("ReturnDate")
                }
                viewDate={new Date(dates.endDate)}
                className="custom-calendar-input"
                onClearButtonClick={()=>{setEndDate(null); setTempEndDate(null)}}
              />
            </div>
          </Col>
        )}
      </Row>

      {apiError ? (
        // Display error from API
        <NotFound
          errorCode={errorData.code}
          errorMessage={errorData.message}
          description={errorData.description}
        />
      ) : data && data.length > 0 ? (
        <>
          {" "}
          <div className="flights-container">
            {data &&
              data.map((flight) => (
                <Flight
                  key={flight.id}
                  item={flight}
                  selectedDestination={selectedDestination}
                  setFlightSelected={setFlightSelected}
                  onSelect={openAddService}     
                />
              ))}
          </div>
          <div className="d-flex justify-content-center mt-5">
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>{" "}
        </>
      ) : (
        <NotFound
          errorCode={"204"}
          errorMessage={t("NoData")}
          description={t("NoFlightAvailable")}
        ></NotFound>
      )}
      <GlobalModal
        title={t("AddFlight")}
        subtitle={t("AreYouSureYouWantToAddThisFlight")}
        globalModal={showPopUp}
        onClick={() => {
          onReturn([flightSelected]);
          setShowPopUp(false);
        }}
        onClose={() => setShowPopUp(false)}
      ></GlobalModal>
    </div>
  );
};

export default ChooseFlightForm;
